<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputLocality" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
</script>

<InputText
    bind:value
    placeholder = 'resource.address.properties.locality.placeholder'
    label = 'resource.address.properties.locality.label'
    name = 'address.locality'
    minLength = { 2 }
    { isDisabled }
    { isReadonly }
    { isRequired }
/>